import apiService from "./api";

const foodService = {
  // Add additional food choice number
  addAdditionalFoodChoiceNumber(number) {
    return apiService.post('/foods/additional-foods-choice-number', number);
  },
  // Add new price for food size
  addSizePrice(data) {
    return apiService.post('/foods/sizes/new-price', data);
  },
  // Delete size price
  deleteSizePrice(size) {
    return apiService.post('/foods/sizes/size-price-delete', size);
  },
  // Add or update additional foods
  addOrUpdateAdditionalFoods(item) {
    return apiService.post('/foods/additional-foods', item);
  },
  // Add new food size
  addNewSize(data) {
    return apiService.post('/foods/sizes-new', data);
  },
  // Delete food size
  deleteSize(size) {
    return apiService.post('/foods/sizes-delete', size);
  },
  // Edit food size
  editSize(editSizes) {
    return apiService.post('/foods/sizes-edit', editSizes);
  },
};

export default foodService;
